import { forwardRef } from "react";
import { sizeVariants } from "./constants";
import {cn} from "@gettactic/helpers";

interface CustomInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> {
  size?: keyof typeof sizeVariants;
  isDragging?: boolean;
}

export const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>(
  ({ className, size = "default", isDragging = false, ...props }, ref) => {
    return (
      <input
        type="number"
        className={cn(
          // Base styles
          "w-full rounded-md transition-all duration-200",
          "bg-muted/50 hover:bg-muted",
          // Border and focus states
          "border-2 border-transparent",
          "outline-none",
          "hover:border-primary/10",
          "focus:border-primary/20 focus:bg-muted",
          isDragging && "border-primary/20 bg-muted",
          // Hide spinner buttons
          "[appearance:textfield]",
          "[&::-webkit-outer-spin-button]:appearance-none",
          "[&::-webkit-inner-spin-button]:appearance-none",
          // Size variant
          sizeVariants[size],
          // Group hover state for dropdown button
          "group-hover:pr-12",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);

CustomInput.displayName = "CustomInput";
